import { C, STROKE, Figure, Label, Leader, ThermostatValve, WaterGradient, arrow } from './figureStyle';

const ID = 'fig-princip';

const channels = Array.from({ length: 10 }, (_, i) => 78 + i * 14);
const fins = Array.from({ length: 16 }, (_, i) => `${i % 2 === 0 ? 255 : 265},${86 + i * 8}`).join(' ');

export default function RadiatorPrincipFigure() {
  return (
    <Figure
      id={ID}
      height={280}
      title="Panelradiator set forfra og fra siden: varmt vand løber ind gennem termostatventilen i toppen, afkøles på vej ned og løber ud i returen i bunden, mens luften varmes mellem konvektorlamellerne og stiger op."
      caption="Panelradiatorens princip: varmt vand løber ind gennem termostatventilen, afkøles på vej ned og ud i returen, mens luften varmes mellem lamellerne og stiger op i rummet."
      defs={<WaterGradient id={`${ID}-water`} y1={88} y2={196} />}
    >
      {/* Radiator set forfra med lodrette vandkanaler */}
      <rect x="64" y="80" width="150" height="130" rx="6" fill={C.page} stroke={C.dark} strokeWidth={STROKE.outline} />
      {channels.map((x) => (
        <line key={x} x1={x} y1="86" x2={x} y2="204" stroke={C.line} strokeWidth={STROKE.secondary} />
      ))}

      {/* Vandets vej: ind i toppen, ned gennem kanalerne, ud i bunden */}
      <path
        d="M70,88 H200 Q208,88 208,96 V188 Q208,196 200,196 H76"
        fill="none"
        stroke={`url(#${ID}-water)`}
        strokeWidth={STROKE.outline}
        markerEnd={arrow(ID, 'cold')}
      />
      <line x1="110" y1="98" x2="110" y2="186" stroke={`url(#${ID}-water)`} strokeWidth={STROKE.secondary} markerEnd={arrow(ID, 'cold')} />
      <line x1="158" y1="98" x2="158" y2="186" stroke={`url(#${ID}-water)`} strokeWidth={STROKE.secondary} markerEnd={arrow(ID, 'cold')} />

      {/* Fremløb gennem termostatventilen */}
      <line x1="6" y1="88" x2="22" y2="88" stroke={C.rust} strokeWidth={STROKE.outline} markerEnd={arrow(ID, 'hot')} />
      <line x1="52" y1="88" x2="64" y2="88" stroke={C.rust} strokeWidth={STROKE.outline} />
      <ThermostatValve cx={39} pipeY={88} />

      {/* Retur i bunden */}
      <line x1="64" y1="196" x2="8" y2="196" stroke={C.grey} strokeWidth={STROKE.outline} markerEnd={arrow(ID, 'cold')} />

      {/* Varm luft op i rummet */}
      {[90, 120, 150].map((x) => (
        <line key={x} x1={x} y1="72" x2={x} y2="48" stroke={C.rust} strokeWidth={STROKE.secondary} markerEnd={arrow(ID, 'hot')} />
      ))}

      {/* Snit set fra siden: to paneler med konvektorlameller imellem */}
      <rect x="244" y="80" width="8" height="130" rx="3" fill={C.light} stroke={C.dark} strokeWidth={STROKE.outline} />
      <rect x="268" y="80" width="8" height="130" rx="3" fill={C.light} stroke={C.dark} strokeWidth={STROKE.outline} />
      <polyline points={fins} fill="none" stroke={C.grey} strokeWidth={STROKE.secondary} />
      <line x1="260" y1="248" x2="260" y2="218" stroke={C.grey} strokeWidth={STROKE.secondary} markerEnd={arrow(ID, 'cold')} />

      {/* Labels */}
      <Label x={6} y={20} lines={['Termostatventil']} />
      <Leader points="39,26 39,41" />
      <Label x={6} y={118} lines={['Fremløb']} />
      <Label x={6} y={222} lines={['Retur']} />
      <Label x={162} y={62} kind="note" lines={['Varm luft op']} />
      <Label x={356} y={28} anchor="end" lines={['Konvektorlameller']} />
      <Leader points="260,34 260,100" />
      <Label x={260} y={268} anchor="middle" kind="note" lines={['Set fra siden']} />
    </Figure>
  );
}
